import React from "react";
import { Helmet } from "react-helmet-async";
import { SITE } from "../mock";

export const SeoMeta = ({ title, description, url }) => {
  const imageUrl = typeof SITE.logoUrl === "string" && SITE.logoUrl.startsWith("http")
    ? SITE.logoUrl
    : `https://www.zdravepacky.cz${SITE.logoUrl}`;

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      {url && <link rel="canonical" href={url} />}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={imageUrl} />
      {url && <meta property="og:url" content={url} />}
      <meta property="og:type" content="website" />
      <meta property="og:locale" content="cs_CZ" />
      <meta property="og:site_name" content={SITE.name} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={imageUrl} />
    </Helmet>
  );
};